









































import {Component, Prop, Mixins} from 'vue-property-decorator'
import radioChoiceMixin from '@/mixins/radioChoiceMixin'
import {newLines} from '@/lib'

@Component
export default class TabBar extends Mixins(radioChoiceMixin) {

  @Prop() readonly classes?: string
  @Prop({ default: false }) readonly formatted?: boolean
  @Prop({ default: false }) readonly placeholder?: boolean
  @Prop({ default: false }) readonly inline?: boolean
  @Prop({ default: (value?: string) => value }) readonly map?: (value?: string) => string

  private setTab(value: any) {
    this.radioValue = value;
  }

  private labelHtml(label: string): string {
    return this.formatted ? newLines(label) : label;
  }

  private numberPlaceholder(i: number, index: number): string {
    return (i === index + 1) ? i.toString() : '';
  }

}
